import styled from 'styled-components'

const Container = styled.div`
  ul {
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 10px;
  }

  li {
    margin-bottom: 7px;
  }
  .fa {
    font-size: 12px;
    margin-left: 5px;
  }
`

const Title = styled.div`
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 5px;
`
const List = ({ title, children, className }) => (
  <Container className={className}>
    {title && <Title>{title}</Title>}

    <ul>{children}</ul>
  </Container>
)

export default List
